import { DialogActions } from '@mui/material';

import { useTranslation } from 'react-i18next';
import Button, { WhiteButton } from '../ui/Button';

import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

interface LocalTypeProps {
  localType: string;
  setLocalType: (value: string) => void;
  onClose: () => void;
  onNext: () => void;
}

const LocalType = ({
  localType,
  setLocalType,
  onClose,
  onNext,
}: LocalTypeProps) => {
  const { t } = useTranslation('cnc-reports');
  return (
    <>
      <RadioGroup
        value={localType}
        onChange={(e) => setLocalType(e.target.value)}
      >
        <FormControlLabel
          value="Interne"
          control={<Radio />}
          label={t('cnc-reports:local-type.internal')}
        />
        <FormControlLabel
          value="Studio partenaire"
          control={<Radio />}
          label={t('cnc-reports:local-type.partner-studio')}
        />
      </RadioGroup>
      <DialogActions>
        <WhiteButton onClick={onClose}>{t('common:cancel')}</WhiteButton>
        <Button onClick={onNext} color="primary" disabled={!localType}>
          {t('common:next')}
        </Button>
      </DialogActions>
    </>
  );
};

export default LocalType;
